<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page5"></a><em>Part 1</em></h1>
<h1 class="subchapter1">Subjectivity, Knowledge, and Human Nature in Neo-Noir</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172309_epub_p01_r1.vue?1f77252b